<div class="w-full flex justify-center px-12 py-6 shadow-sm gap-2">
  <button
    class="bg-purple-600 text-white rounded-md p-3 flex items-center mx-4"
    (click)="previewMode = !previewMode"
  >
    <mat-icon class="mr-2">remove_red_eye</mat-icon>
    {{ previewMode ? "Masquer" : "Afficher" }}
  </button>
  <button
    class="bg-blue-800 text-white rounded-md p-3 flex items-center mx-4"
    (click)="imprimer2()"
  >
    <mat-icon class="mr-2"> local_printshop</mat-icon>Imprimer
  </button>
  <button
    class="bg-green-600 text-white rounded-md p-3 flex items-center mx-4"
    (click)="openDialogAdd()"
  >
    <mat-icon class="mr-2">add</mat-icon>Ajouter
  </button>
</div>
<mat-card>
  <mat-card-content>
    <mat-card *ngIf="previewMode">
      <!-- <mat-card-content>
        <div class="text-xl mt-20">
          <div class="flex justify-center">
            <img src="assets/cnamLogo.png" alt="" class="w-2/6" />
          </div>
          <div class="text-4xl text-center">
            DECLARATION DE RECRUTEMENT DE NOUVEAUX EMPLOYÉS
          </div>
          <div class="text-center text-2xl">
            Loi n° 94-28 du 21 février 1994 relative à la réparation des préjudices
          </div>
          <div class="text-center text-2xl">
            résultant des accidents du travail et des maladies professionnelles
          </div>
        </div>
      </mat-card-content> -->
    </mat-card>
    <mat-card>
      <div fxLayout="row" fxLayoutAlign="center center">
        <mat-card-title>Remplir Les Champs </mat-card-title>
      </div>
      <mat-card-content>
        <br />
        <div *ngIf="ListSoc">
          <mat-form-field appearance="legacy">
            <mat-label>Choisir une Societé</mat-label>
            <mat-select (selectionChange)="selectSoc($event.value)">
              <mat-option *ngFor="let soc of ListSoc" [value]="soc.SOC_RS">{{
                soc.SOC_RS
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div fxFlex="3"></div>
        <app-recherche
          [style]="{ width: '130px', 'margin-right': '10px' }"
          [api]="api"
          [(ngModel)]="nomEtPrenomSoussigne"
          [numColonneToShow]="1"
          [numColonneToReturn]="0"
          (ChampEnter)="blurPersoSS($event)"
          recherche="API_PersoCnamSig"
          [param]="idSoc"
          placeholder="Nom & Prénom"
        >
        </app-recherche>

        <!-- <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
          <mat-label>Je soussigné</mat-label>
          <input matInput type="text" [(ngModel)]="nomEtPrenomSoussigne" class="input mdc-text-field__input">
        </mat-form-field> -->
        <div fxFlex="3"></div>
        <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
          <mat-label>En ma qualité de</mat-label>
          <input
            matInput
            type="text"
            [(ngModel)]="quliteDe"
            class="input mdc-text-field__input"
          />
        </mat-form-field>
        <div fxFlex="3"></div>
        <!-- <mat-form-field appearance="legacy" fxFlex="25">
          <mat-label>Date de recrutemente</mat-label>
          <input matInput [matDatepicker]="DaterecSelect" [(ngModel)]="DaterecSelect" class="input"
            (dateChange)="dateRecChangeGetByDay()">
          <mat-datepicker-toggle matSuffix [for]="DaterecSelect"></mat-datepicker-toggle>
          <mat-datepicker #DaterecSelect></mat-datepicker>
        </mat-form-field> -->
        <mat-form-field appearance="legacy" fxFlex="12">
          <mat-label>Depuis</mat-label>
          <input
            matInput
            [matDatepicker]="DateSelect"
            class="input"
            [(ngModel)]="DateRecSelect"
            (dateChange)="dateRecChangeGetByDay()"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="DateSelect"
          ></mat-datepicker-toggle>
          <mat-datepicker #DateSelect></mat-datepicker>
        </mat-form-field>
      </mat-card-content>
    </mat-card>
    <mat-card>
      <mat-card-content>
        <div fxLayout="row" fxLayoutAlign="center center">
          <!-- <table class="border-collapse border-2 border-black mt-20" id="tableEmbauche">
            <thead>
              <tr>
                <th class="border-2 border-black" style="width: 15%">
                  Identité complète
                </th>
                <th class="border-2 border-black" style="width: 4%">Sexe</th>
                <th class="border-2 border-black">Date de naissance</th>
                <th class="border-2 border-black">
                  Numéro de la carte d’identité nationale
                </th>
                <th class="border-2 border-black">N° C.N.S.S s’il existe</th>
                <th class="border-2 border-black" style="width: 15%">Adresse</th>
                <th class="border-2 border-black">Date de recrutement</th>
                <th class="border-2 border-black" style="width: 10%">
                  Statut professionnel
                </th>
                <th class="grid grid-cols-2">
                  <span class="col-span-2 border-b-2 border-black">Salaire convenu</span>
                  <span class="">Montant</span>
                  <span class="border-l-2 border-black">Par</span>
                </th>
                <th class="border-2 border-black"></th>
              </tr>
            </thead>
            <tbody *ngFor="let emb of ListEmbaucheDay">
              <tr>
                <td class="border-2 border-black">
                  {{emb.IDComplete}}
                </td>
                <td class="border-2 border-black">
                  {{emb.Sexe}}
                </td>
                <td class="border-2 border-black">
                  {{emb.Date_Naissance}}
                </td>
                <td class="border-2 border-black">
                  {{emb.Num_CIDN}}
                </td>
                <td class="border-2 border-black">
                  {{emb.NUM_CNSS}}
                </td>
                <td class="border-2 border-black">
                  {{emb.Adresse}}
                </td>
                <td class="border-2 border-black">
                  {{emb.Date_Recrutement}}
                </td>
                <td class="border-2 border-black">
                  {{emb.StatutProf}}
                </td>
                <td class="border-2 border-black">
                  {{emb.Salaire}}
                </td>
                <td class="border-2 border-black">
                  <mat-icon (click)="modifer(emb)">update</mat-icon>
                  <mat-icon (click)="openDialogue(emb)">delete</mat-icon>
                </td>
              </tr>
            </tbody>
          </table> -->
          <table
            mat-table
            [dataSource]="dataSource"
            class="mat-elevation-z8"
            *ngIf="ListEmbaucheDay"
          >
            <!--- Note that these columns can be defined in any order.
                  The actual rendered columns are set as a property on the row definition" -->
            <!-- Position Column -->

            <ng-container matColumnDef="IDComplete">
              <th mat-header-cell *matHeaderCellDef>Identité complète</th>
              <td mat-cell *matCellDef="let element">
                {{ element.IDComplete }}
              </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="Sexe">
              <th mat-header-cell *matHeaderCellDef>Sexe</th>
              <td mat-cell *matCellDef="let element">{{ element.Sexe }}</td>
            </ng-container>
            <ng-container matColumnDef="Date_Naissance">
              <th mat-header-cell *matHeaderCellDef>Date de naissance</th>
              <td mat-cell *matCellDef="let element">
                {{ element.Date_Naissance }}
              </td>
            </ng-container>

            <!-- Weight Column -->
            <ng-container matColumnDef="Num_CIDN">
              <th mat-header-cell *matHeaderCellDef>CIN</th>
              <td mat-cell *matCellDef="let element">{{ element.Num_CIDN }}</td>
            </ng-container>
            <ng-container matColumnDef="NUM_CNSS">
              <th mat-header-cell *matHeaderCellDef>CNSS</th>
              <td mat-cell *matCellDef="let element">{{ element.NUM_CNSS }}</td>
            </ng-container>
            <ng-container matColumnDef="Adresse">
              <th mat-header-cell *matHeaderCellDef>Adresse</th>
              <td mat-cell *matCellDef="let element">{{ element.Adresse }}</td>
            </ng-container>
            <ng-container matColumnDef="Date_Recrutement">
              <th mat-header-cell *matHeaderCellDef>Date Embauche</th>
              <td mat-cell *matCellDef="let element">
                {{ element.Date_Recrutement }}
              </td>
            </ng-container>
            <ng-container matColumnDef="StatutProf">
              <th mat-header-cell *matHeaderCellDef>Status</th>
              <td mat-cell *matCellDef="let element">
                {{ element.StatutProf }}
              </td>
            </ng-container>
            <ng-container matColumnDef="Salaire">
              <th mat-header-cell *matHeaderCellDef>Salaire</th>
              <td mat-cell *matCellDef="let element">{{ element.Salaire }}</td>
            </ng-container>
            <ng-container matColumnDef="Action">
              <th mat-header-cell *matHeaderCellDef>Action</th>
              <td mat-cell *matCellDef="let emb">
                <mat-icon (click)="modifer(emb)">update</mat-icon>
                <mat-icon (click)="openDialogue(emb)">delete</mat-icon>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </div>
      </mat-card-content>
    </mat-card>
  </mat-card-content>
  <mat-card-footer>
    <div fxLayout="row" fxLayoutAlign="end center">
      <div fxFlex="3"></div>
      <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
        <mat-label>Fait à</mat-label>
        <input matInput type="text" [(ngModel)]="ville" class="input" />
      </mat-form-field>
      <div fxFlex="3"></div>
      <mat-form-field id="example-full-width" appearance="legacy" fxFlex="12">
        <mat-label>Le </mat-label>
        <input
          matInput
          [matDatepicker]="pickerDateLe"
          [(ngModel)]="Apreslel"
          (dateChange)="dateLe()"
          class="input"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="pickerDateLe"
        ></mat-datepicker-toggle>
        <mat-datepicker #pickerDateLe></mat-datepicker>
      </mat-form-field>
    </div>
  </mat-card-footer>
</mat-card>

<div class="py-8 px-50 flex flex-col justify-center">
  <ng-container *ngIf="previewMode">
    <div class="w-full border-2 border-black my-8 flex flex-col text-xl" hidden>
      <div class="flex w-full">
        <div class="border-r-2 border-b-2 border-black px-3">Employeur</div>
        <div class="w-full text-center">
          N° d'affiliation à la CNSS<input
            type="text"
            [(ngModel)]="numCNSSEmployeur"
          />
        </div>
      </div>
      <div class="flex w-full ml-3">
        <div>Nom ou RS :</div>
        <input type="text" [(ngModel)]="raisonSocial" />
      </div>
      <div class="flex w-full mb-3 ml-3">
        <div class="w-1/2 flex mb-2">
          <div>Adresse :</div>
          <input type="text" [(ngModel)]="adresseEmployeur_1" />
        </div>

        <div class="w-1/2 flex">
          <div>Code postal :</div>
          <input type="text" [(ngModel)]="codePost" />
          <div>Tél :</div>
          <input type="text" [(ngModel)]="numTel" />
        </div>
      </div>
    </div>
  </ng-container>
</div>
<ng-template #frmNewEmb>
  <ng-container class="py-8 w-full" fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="center center">
      <mat-card-title
        style="color: #1021c0"
        class="text-center text-2xl font-medium leading-normal"
        >Nouveau Embauche
      </mat-card-title>
    </div>
    <div fxLayout="column">
      <fieldset>
        <legend>Donnée Liée à La Personne</legend>
        <div fxLayout="row" fxLayoutAlign="center center">
          <mat-form-field
            id="example-full-width"
            appearance="legacy"
            fxFlex="25"
          >
            <mat-label>Nom</mat-label>
            <!-- <mat-icon matSuffix [hidden]="nom">sentiment_very_dissatisfied</mat-icon>
          <mat-icon matSuffix [hidden]="!nom">sentiment_very_satisfied</mat-icon> -->
            <input
              matInput
              type="text"
              [(ngModel)]="nom"
              class="input"
              required
            />
          </mat-form-field>
          <div fxFlex="5"></div>
          <mat-form-field
            id="example-full-width"
            appearance="legacy"
            fxFlex="25"
          >
            <mat-label>Prénom</mat-label>
            <!-- <mat-icon matSuffix [hidden]="prenom">sentiment_very_dissatisfied</mat-icon>
          <mat-icon matSuffix [hidden]="!prenom">sentiment_very_satisfied</mat-icon> -->
            <input
              matInput
              type="text"
              [(ngModel)]="prenom"
              class="input"
              required
            />
          </mat-form-field>
          <div fxFlex="5"></div>
          <mat-form-field
            id="example-full-width"
            appearance="legacy"
            fxFlex="25"
            required
          >
            <mat-label>Sexe</mat-label>
            <mat-select
              (selectionChange)="selectSexe($event.value)"
              [(ngModel)]="sexe"
              required
            >
              <mat-option *ngFor="let s of sex" [value]="s.key">{{
                s.value
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="center center">
          <mat-form-field appearance="legacy" fxFlex="25">
            <mat-label>Date de naissance</mat-label>
            <input
              matInput
              [matDatepicker]="pickerDateNais"
              id="naissance"
              class="input"
              required
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="pickerDateNais"
            ></mat-datepicker-toggle>
            <mat-datepicker #pickerDateNais></mat-datepicker>
          </mat-form-field>
          <div fxFlex="5"></div>
          <mat-form-field appearance="legacy" fxFlex="25">
            <mat-label>Lieu Naissance</mat-label>
            <!-- <mat-icon matSuffix [hidden]="lieuNais">sentiment_very_dissatisfied</mat-icon>
          <mat-icon matSuffix [hidden]="!lieuNais">sentiment_very_satisfied</mat-icon> -->
            <input matInput type="text" [(ngModel)]="lieuNais" class="input" />
          </mat-form-field>
          <div fxFlex="5"></div>
          <!-- <mat-form-field appearance="legacy">
          <mat-label>Choisir une Fonction</mat-label>
          <mat-select (selectionChange)="selectFonc($event.value)" [(ngModel)]="fonction">
            <mat-option *ngFor="let fonc of listFonction" [value]="fonc.DiverSys_Index">{{fonc.DiverSys_Titre}}
            </mat-option>
          </mat-select>
        </mat-form-field> -->
          <mat-form-field
            id="example-full-width"
            appearance="legacy"
            fxFlex="25"
          >
            <mat-label>Nationalité</mat-label>
            <!-- <mat-icon matSuffix [hidden]="nat">sentiment_very_dissatisfied</mat-icon>
          <mat-icon matSuffix [hidden]="!nat">sentiment_very_satisfied</mat-icon> -->
            <input matInput type="text" [(ngModel)]="nat" class="input" />
          </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="center center">
          <mat-form-field
            id="example-full-width"
            appearance="legacy"
            fxFlex="25"
          >
            <mat-label>Nom Jeune Fille</mat-label>
            <!-- <mat-icon matSuffix [hidden]="nomJfille">sentiment_very_dissatisfied</mat-icon>
          <mat-icon matSuffix [hidden]="!nomJfille">sentiment_very_satisfied</mat-icon> -->
            <input matInput type="text" [(ngModel)]="nomJfille" class="input" />
          </mat-form-field>
          <div fxFlex="5"></div>
          <mat-form-field
            id="example-full-width"
            appearance="legacy"
            fxFlex="25"
          >
            <mat-label>Prénom Pére</mat-label>
            <!-- <mat-icon matSuffix [hidden]="prenomPere">sentiment_very_dissatisfied</mat-icon>
          <mat-icon matSuffix [hidden]="!prenomPere">sentiment_very_satisfied</mat-icon> -->
            <input
              matInput
              type="text"
              [(ngModel)]="prenomPere"
              class="input"
            />
          </mat-form-field>
          <div fxFlex="5"></div>
          <mat-form-field
            id="example-full-width"
            appearance="legacy"
            fxFlex="25"
          >
            <mat-label>Identité complète</mat-label>
            <!-- <mat-icon matSuffix [hidden]="id">sentiment_very_dissatisfied</mat-icon>
          <mat-icon matSuffix [hidden]="!id">sentiment_very_satisfied</mat-icon> -->
            <input
              matInput
              type="text"
              [(ngModel)]="id"
              class="input mdc-text-field__input"
              required
            />
          </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="center center">
          <mat-form-field
            id="example-full-width"
            appearance="legacy"
            fxFlex="25"
          >
            <mat-label>CIN</mat-label>
            <!-- <mat-icon matSuffix [hidden]="cin">sentiment_very_dissatisfied</mat-icon>
          <mat-icon matSuffix [hidden]="!cin">sentiment_very_satisfied</mat-icon> -->
            <input
              matInput
              type="text"
              [(ngModel)]="cin"
              class="input"
              required
            />
          </mat-form-field>
          <div fxFlex="5"></div>
          <mat-form-field
            id="example-full-width"
            appearance="legacy"
            fxFlex="25"
          >
            <mat-label>N° C.N.S.S s’il existe</mat-label>
            <!-- <mat-icon matSuffix [hidden]="cnss">sentiment_very_dissatisfied</mat-icon>
          <mat-icon matSuffix [hidden]="!cnss">sentiment_very_satisfied</mat-icon> -->
            <input matInput type="text" [(ngModel)]="cnss" class="input" />
          </mat-form-field>
          <div fxFlex="5"></div>
          <mat-form-field appearance="legacy" fxFlex="25">
            <mat-label>Adresse</mat-label>
            <textarea
              matInput
              rows="1"
              [(ngModel)]="adresse"
              required
            ></textarea>
          </mat-form-field>
        </div>
      </fieldset>
      <!-- <div fxLayoutAlign="center center">
        <div class=""
          style="border-bottom:1px solid rgb(141, 139, 139);height:auto; margin-right:10px; width: 50%; right: 50%;">
        </div>
      </div>
      <br> -->
      <fieldset>
        <legend>Donnée Liée à La Societé</legend>
        <div fxLayout="row" fxLayoutAlign="center center">
          <mat-form-field appearance="legacy" fxFlex="25">
            <mat-label>Date Embauche</mat-label>
            <input
              matInput
              [matDatepicker]="pickerDateRec"
              id="recrutement"
              class="input"
              required
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="pickerDateRec"
            ></mat-datepicker-toggle>
            <mat-datepicker #pickerDateRec></mat-datepicker>
          </mat-form-field>
          <div fxFlex="5"></div>
          <mat-form-field
            id="example-full-width"
            appearance="legacy"
            fxFlex="25"
          >
            <mat-label>Statut</mat-label>
            <!-- <mat-icon matSuffix [hidden]="stat">sentiment_very_dissatisfied</mat-icon>
          <mat-icon matSuffix [hidden]="!stat">sentiment_very_satisfied</mat-icon> -->
            <input
              matInput
              type="text"
              [(ngModel)]="stat"
              class="input"
              required
            />
          </mat-form-field>
          <div fxFlex="5"></div>
          <!-- <mat-form-field id="example-full-width" appearance="legacy" fxFlex="25">
          <mat-label>Montant</mat-label>
          <mat-icon matSuffix [hidden]="montant">sentiment_very_dissatisfied</mat-icon>
          <mat-icon matSuffix [hidden]="!montant">sentiment_very_satisfied</mat-icon>
          <input matInput type="number" [(ngModel)]="montant" class="input">
        </mat-form-field> -->
          <mat-form-field
            id="example-full-width"
            appearance="legacy"
            fxFlex="25"
          >
            <mat-label>Emploi Habituel</mat-label>
            <!-- <mat-icon matSuffix [hidden]="empHab">sentiment_very_dissatisfied</mat-icon>
          <mat-icon matSuffix [hidden]="!empHab">sentiment_very_satisfied</mat-icon> -->
            <input matInput type="text" [(ngModel)]="empHab" class="input" />
          </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="center center">
          <mat-form-field
            id="example-full-width"
            appearance="legacy"
            fxFlex="25"
          >
            <mat-label>Qualification Professionnelle</mat-label>
            <!-- <mat-icon matSuffix [hidden]="qualprof">sentiment_very_dissatisfied</mat-icon>
          <mat-icon matSuffix [hidden]="!qualprof">sentiment_very_satisfied</mat-icon> -->
            <input matInput type="text" [(ngModel)]="qualprof" class="input" />
          </mat-form-field>
          <div fxFlex="5"></div>
          <mat-form-field appearance="legacy" fxFlex="25">
            <mat-label>Depuis</mat-label>
            <input
              matInput
              [matDatepicker]="pickerDateDec"
              id="DateRecSelectPost"
              class="input"
              (dateChange)="datePostDec()"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="pickerDateDec"
            ></mat-datepicker-toggle>
            <mat-datepicker #pickerDateDec></mat-datepicker>
          </mat-form-field>
          <div fxFlex="5"></div>
          <mat-form-field id="list_soc" appearance="legacy" fxFlex="25">
            <mat-label>Choisir une Societé</mat-label>
            <mat-select
              (selectionChange)="selectSocEmp($event.value)"
              [(ngModel)]="idSocSel"
              required
            >
              <mat-option *ngFor="let soc of ListSoc" [value]="soc.SOC_ID">{{
                soc.SOC_RS
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div fxLayoutAlign="center center">
          <span fxLayoutAlign="space-between center">Droit de soussigné ?</span>
          <div fxFlex="1"></div>
          <mat-radio-group
            fxLayoutAlign="space-between center"
            [(ngModel)]="peroSig"
            (change)="selectRespo($event)"
            required
          >
            <mat-radio-button value="1">Oui </mat-radio-button>
            &nbsp;&nbsp;
            <mat-radio-button value="0">Non </mat-radio-button>
          </mat-radio-group>
        </div>
      </fieldset>
    </div>
    <br />
    <div fxLayout="row" fxLayoutAlign="end ">
      <div class="flex flex-row gap-2">
        <button
          mat-raised-button
          color="primary"
          [mat-dialog-close]="true"
          cdkFocusInitial
          (click)="add()"
        >
          <mat-icon class="mr-2">add</mat-icon>Ajouter
        </button>
        <button
          mat-raised-button
          color="disabled"
          [mat-dialog-close]="true"
          cdkFocusInitial
          (click)="clear()"
        >
          <mat-icon class="mr-2">clear_all</mat-icon>Vider
        </button>
        <button
          mat-raised-button
          color="warn"
          [mat-dialog-close]="true"
          cdkFocusInitial
          (click)="close()"
        >
          <mat-icon class="mr-2">close</mat-icon>Fermer
        </button>
      </div>
    </div>
    <!-- <app-collaborateur></app-collaborateur> -->
  </ng-container>
  <!-- <mat-progress-bar mode="indeterminate"></mat-progress-bar> -->
</ng-template>
<div id="declarationNouveauEmp" hidden>
  <div *ngFor="let doc of splitBy(ListEmbaucheDay, 5)">
    <span style="position: absolute; top: 81px; left: 217px">
      {{ raisonSocial }}
    </span>
    <span style="position: absolute; top: 56px; left: 900px">
      {{ numCNSSEmployeur }}
    </span>
    <span style="position: absolute; top: 120px; left: 120px">
      {{ adresseEmployeur_1 }}
    </span>
    <span style="position: absolute; top: 125px; left: 792px">
      {{ codePost }}
    </span>
    <span style="position: absolute; top: 264px; left: 195px">
      {{ nomEtPrenomSoussigne1 }}
    </span>
    <span style="position: absolute; top: 120px; left: 880px">
      {{ numTel }}
    </span>
    <span style="position: absolute; top: 262px; left: 605px">
      {{ quliteDe }}
    </span>
    <div *ngIf="doc.length <= 5">
      <div *ngFor="let embR of doc">
        <span [ngStyle]="embR.StyleSpanId"> {{ embR.IDComplete }}</span>
        <span *ngIf="embR.Sexe == 'Homme'" [ngStyle]="embR.StyleSpanSexe">
          H</span
        >
        <span *ngIf="embR.Sexe == 'Femme'" [ngStyle]="embR.StyleSpanSexe">
          F</span
        >
        <span [ngStyle]="embR.StyleSpanNais"> {{ embR.Date_Naissance }}</span>
        <span [ngStyle]="embR.StyleSpanCin"> {{ embR.Num_CIDN }}</span>
        <span [ngStyle]="embR.StyleSpanCnss"> {{ embR.NUM_CNSS }}</span>
        <span [ngStyle]="embR.StyleSpanAdr"> {{ embR.Adresse }}</span>
        <span [ngStyle]="embR.StyleSpanRec"> {{ embR.Date_Recrutement }}</span>
        <span [ngStyle]="embR.StyleSpanStat"> {{ embR.StatutProf }}</span>
        <span [ngStyle]="embR.StyleSpanMont"> {{ embR.Salaire }}</span>
      </div>
    </div>
    <!-- <div *ngIf="ListEmbaucheDay.length>5">
      <div *ngIf="Tab">
      <div *ngFor="let embR of Tab;let i = index">
        <span [ngStyle]="StyleSpanId ">
          {{embR.IDComplete}}</span>
        <span [ngStyle]="StyleSpanSexe">
          {{embR.Sexe}}</span>
        <span [ngStyle]="StyleSpanNais">
          {{embR.Date_Naissance}}</span>
        <span [ngStyle]="StyleSpanCin">
          {{embR.Num_CIDN}}</span>
        <span [ngStyle]="StyleSpanCnss">
          {{embR.NUM_CNSS}}</span>
        <span [ngStyle]="StyleSpanAdr">
          {{embR.Adresse}}</span>
        <span [ngStyle]="StyleSpanRec">
          {{embR.Date_Recrutement}}</span>
        <span [ngStyle]="StyleSpanStat">
          {{embR.StatutProf}}</span>
        <span [ngStyle]="StyleSpanMont">
          {{embR.Salaire}}</span>
      </div>
    </div>
      </div> -->

    <span style="position: absolute; top: 728px; left: 739px">
      {{ ville }}
    </span>

    <span style="position: absolute; top: 728px; left: 880px">
      {{ Apresle }}
    </span>
  </div>
</div>

<ng-template #frmDelete>
  <ng-container class="py-8 w-full" fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="center center">
      <mat-card-title style="color: #1e88e5" class="text-4xl text-center"
        >Voulez vous Supprimer ?
      </mat-card-title>
    </div>
    <br />
    <div fxLayout="row" fxLayoutAlign="center center">
      <button
        mat-raised-button
        color="primary"
        [mat-dialog-close]="true"
        cdkFocusInitial
        (click)="supprimer()"
      >
        <mat-icon class="mr-2">check</mat-icon>Oui
      </button>
      <div fxFlex="10"></div>
      <button
        mat-raised-button
        color="warn"
        [mat-dialog-close]="true"
        cdkFocusInitial
        (click)="close()"
      >
        <mat-icon class="mr-2">close</mat-icon>Non
      </button>
    </div>
  </ng-container>
</ng-template>
